import React from 'react';
import './Skills.css';
import { SiCsharp } from 'react-icons/si';
import { SiJavascript } from 'react-icons/si';
import { SiReact } from 'react-icons/si';
import { SiHtml5 } from 'react-icons/si';
import { SiCss3 } from 'react-icons/si';
import { AiOutlineConsoleSql } from 'react-icons/ai';
import { SiBootstrap } from 'react-icons/si';
import { DiGit } from 'react-icons/di';

const Skills = () => {
  return (
    <div className="skills-container" id="skills">
      <div className="skills-main">
        <div className="skills-left">
          <hr width="300"></hr>
          <h1>Skills.</h1>
        </div>
        <div className="skills-right">
          <ul className="skills-ul-01">
            <li className="js-li">
              <SiJavascript />
              <p>Javascript</p>
            </li>
            <li className="react-li">
              <SiReact />
              <p>React</p>
            </li>
            <li className="html-li">
              <SiHtml5 />
              <p>Html 5 </p>
            </li>
            <li className="css-li">
              <SiCss3 />
              <p>Css 3</p>
            </li>
          </ul>

          <ul className="skills-ul-02">
            <li className="csharp-li">
              <SiCsharp />
              <p>C#</p>
            </li>
            <li className="sql-li">
              <AiOutlineConsoleSql />
              <p>Sql</p>
            </li>
            <li className="boostrap-li">
              <SiBootstrap />
              <p>Bootstrap</p>
            </li>
            <li className="git-li">
              <DiGit />
              <p>Git</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Skills;
